import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { useBreakpoint } from '../../styles/breakpoints';
import { SiteNavigation } from './SiteNavigation';
import { Colors } from '../../styles/colors';
import { BreadCrumb, BreadCrumbItem } from './BreadCrumb';
import { BoxedContainer } from './Layout';

export interface MarginalItemProps {
  icon: string;
  text: string;
  route?: string;
  actionFn?: () => void;
}

export interface PageWrapperProps {
  breadCrumb?: BreadCrumbItem[];
  marginal?: {
    headline?: string;
    items: MarginalItemProps[];
    additionalRender?: () => ReactNode;
  };
}

const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 2rem;
  position: relative;
  width:100%;

  .app & {
    padding: 0;
  }
`;

const StyledInnerPageWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: stretch;
  
  ${useBreakpoint('l')} {
    flex-direction: row;
    align-items: flex-start;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 2rem 0;
  
  ${useBreakpoint('l')}{
    flex: 1;
    min-width: 0;
    padding: 0 2rem 2rem 0;
  }
  
  &:last-child {
    padding: 0 0 2rem 0;
  }
`;

const MarginalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  ${useBreakpoint('m')}{
    flex-shrink: 0;
    min-width: 0;
  }
`;

const MarginalHeadline = styled.div`
  display: flex;
  flex-direction: row;
  color: ${Colors.grayDark};
  font-weight: 700;
  min-height: 1.5rem;
  margin: 0 1.5rem 1rem;
`;

export const PageWrapper: FC<PageWrapperProps> = (props) => {
  const { breadCrumb, marginal, children } = props;

  return (
    <StyledPageWrapper>
      <BoxedContainer>
        <BreadCrumb items={breadCrumb}/>
        <StyledInnerPageWrapper>
          <ContentWrapper>
            {children}
          </ContentWrapper>
          {
            (marginal?.items?.length > 0) &&
            <MarginalWrapper>
              <MarginalHeadline>
                {marginal?.headline ? marginal.headline : 'Services'}
              </MarginalHeadline>
              <SiteNavigation items={marginal?.items}/>
              {
                marginal.additionalRender && marginal.additionalRender()
              }
            </MarginalWrapper>
          }
        </StyledInnerPageWrapper>
      </BoxedContainer>
    </StyledPageWrapper>
  );
};
